
  Vue.component('widget-seo-job-item-alone', {
    props: {
      profile: { type: Object },
      updateItemSkills: { type: Function }
    },
    data() {
      return {
        initialSkills: [0, 1, 2, 3, 4],
        selectedSkills: [0, 1, 2, 3, 4]
      }
    },
    template: '#widget-seo-job-item-alone',
    computed: {},
    watch: {},
    methods: {
      selectSkill(number) {
        const index = this.selectedSkills.indexOf(number)

        if (index !== -1) {
          this.selectedSkills.splice(index, 1)
        } else {
          this.selectedSkills.push(number)
        }

        this.updateItemSkills(this.selectedSkills)
      },
      ottieniIniziali(testo) {
        const parole = testo.split(/\s+/).filter(stringa => stringa.length > 2)

        // Inizializza una stringa per contenere le iniziali
        let iniziali = ''

        if (parole.length > 2)
          for (let i = 0; i < Math.min(2, parole.length); i++) {
            iniziali += parole[i].substring(0, 1)
          }
        iniziali = iniziali.length < 2 ? parole[0].substring(0, 2) : iniziali

        return iniziali
      }
    },
    mounted() {}
  })
